/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { reactSelectStyle, getCustomStyles } from "Config/Config";

const AssignCompanyMemberModal = ({
  selectedCompanies,
  setShowAlert,
  setAlertMessage,
  setMessageType,
  onModalClose = () => {},
}) => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [rolesList, setRolesList] = useState([]);

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [isAdding, setIsAdding] = useState(false);

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  //** Function for Validation (updated for correctness and clarity) */
  const validateForm = () => {
    const newErrors = {};
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Case 1: User must be selected.
    if (!userValue || userEmail === "") {
      newErrors.user = t("Please select or invite a user by name or email.");
    }

    // Case 2: User email field must not be empty.
    // Run further checks only if an email is provided
    if (userEmail !== "" && !userEmail.match(mailformat)) {
      newErrors.userEmailIsNotValid = t("Invalid email format") + " !";
    }

    // Case 4: User cannot add themselves.
    if (userInfo.email === userEmail) {
      newErrors.userEmailExists =
        t("You cannot add yourself as a member.") + " !";
    }

    // Role validation
    if (!roleValue) {
      newErrors.role = t("Please assign a role to this member.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `` +
        `&userstringinput=${userInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
  };

  //function for get all roles
  const getAllCompanyRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MODULE_ROLES +
        `?slug=MOD_COMPANY`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRolesList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null);
      val.email ? setUserEmail(val.email) : setUserEmail(val.value);
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }
    // Clear all user-related errors on change
    if (errors.user || errors.userEmailExists || errors.userEmailIsNotValid) {
      setErrors((prev) => ({
        ...prev,
        user: "",
        userEmailExists: "",
        userEmailIsNotValid: "",
      }));
    }
    setErrorMessage("");
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
    } else {
      setRoleValue(null);
      setRoleData(null);
    }
    if (errors.role) {
      setErrors((prev) => ({ ...prev, role: "" }));
    }
  };

  const assignCompanyMemberHandler = async () => {
    if (validateForm()) {
      setIsAdding(true);
      try {
        let assignCompanyMemberData = {
          companyids: selectedCompanies,
          userid: userId,
          userrole: roleData,
          useremail: userEmail,
        };

        // console.log("assignCompanyMemberData---->", assignCompanyMemberData);

        let requestUrl =
          url.API_BASE_URL +
          url.API_ASSIGN_BULK_COMPANY_MEMBER +
          ``;

        const response = await postData(requestUrl, assignCompanyMemberData);

        setIsAdding(false);

        if (response.status) {
          setMessageType("success");
          onModalClose();

          //hide modal
          const bootstrapModal = document.querySelector(
            "#assignCompanyMemberModal"
          );
          const modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();
        } else {
          setMessageType("error");
          setErrorMessage(response.message);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please fill up required fields");
    }
    setShowAlert(true);
  };

  //** Function for reset all states
  const resetHandler = () => {
    setUserValue(null);
    setuserOptions([]);
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setRoleValue(null);
    setRoleData(null);
    setMemberShipStatusValue(null);
    setmemberShipData(null);
    setErrorMessage("");
    setErrors({});
  };

  useEffect(() => {
    getAllCompanyRoles();
  }, []);

  useEffect(() => {
    if (userInput.length > 2) {
      getUserList();
    }
  }, [userInput]);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  return (
    <div
      className="modal fade"
      id="assignCompanyMemberModal"
      tabIndex="-1"
      aria-labelledby="assignCompanyMemberModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  person_add
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-2 text-white mb-0"
                  id="assignCompanyMemberModalLabel"
                >
                  {t("Assign Company Member")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Assign multiple companies to a user.")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                resetHandler();
                onModalClose();
              }}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              {isAdding && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold">
                    Assigning company members, please wait...
                  </p>
                </div>
              )}
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Assign app users / contact (search by name, email)")}
                  </label>
                  <div className="d-flex align-items-center">
                    <Select
                      isClearable
                      className="w-100"
                      placeholder={t("Search by name, email")}
                      options={optionsToShow}
                      value={userValue}
                      onChange={(val) => {
                        userSelectionHandler(val);
                        setErrors((prev) => ({
                          ...prev,
                          user: "",
                          userEmailExists: "",
                          userEmailIsNotValid: "",
                        }));
                        setErrorMessage("");
                      }}
                      onInputChange={(val) => {
                        userInputHandler(val);
                        setErrors((prev) => ({
                          ...prev,
                          user: "",
                          userEmailExists: "",
                          userEmailIsNotValid: "",
                        }));
                        setErrorMessage("");
                      }}
                      styles={getCustomStyles(
                        errors.user ||
                          errors.userEmail ||
                          errors.userEmailIsNotValid ||
                          errors.userEmailExists
                      )}
                    />
                  </div>
                  {/* <!-- ========== Start user validation Section ========== --> */}
                  {errors.user && (
                    <div className="invalid-feedback d-block">
                      {errors.user}
                    </div>
                  )}
                  {/* <!-- ========== End user validation Section ========== --> */}

                  {/* <!-- ========== End company warning Section ========== --> */}
                </div>
                {/* ----- user select section end ----- */}

                {/* ----- role select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Role")} *
                  </label>

                  <Select
                    isClearable
                    styles={getCustomStyles(errors.role)}
                    className="w-100"
                    placeholder={t("Assign a role to the member")}
                    options={rolesList}
                    value={roleValue}
                    onChange={roleSelectionHandler}
                  />
                  {errors.role && (
                    <div className="invalid-feedback d-block">
                      {errors.role}
                    </div>
                  )}
                </div>
                {/* ----- role select section end ----- */}

                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  {/* <!-- ========== Start save button Section ========== --> */}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={assignCompanyMemberHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Assigning...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          person_add
                        </span>{" "}
                        {t("Assign Company Members")}
                      </>
                    )}
                  </button>
                  {/* <!-- ========== End save button Section ========== --> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignCompanyMemberModal;
